import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'attendance/clock-in',
  children: {
    periodTypeYearMonthDay: {
      size: 'full',
      path: ':periodType/:year/:month/:day',
      children: {
        exportsEmployeeId: {
          path: 'exports/:employeeId',
        },
        requestOvertimeEmployeeId: {
          path: 'requestOvertime/:employeeId',
        },
        overtimeRequestEmployeeId: {
          path: 'overtimeRequest/:employeeId',
        },
        workedHoursBreakdownEmployeeId: {
          path: ':employeeId/worked-hours-breakdown',
        },
        balanceBreakdownEmployeeId: {
          path: ':employeeId/balance-breakdown',
        },
        compensationBreakdownEmployeeId: {
          path: ':employeeId/compensation-breakdown',
        },
        bankOfHoursEmployeeId: {
          path: ':employeeId/bank-of-hours-breakdown',
        },
      },
    },
  },
} as const satisfies Location
